export const stripe_prices = {
  dev: {
    'price_1Iks2HE7ozuiLxH2mxptRAvo': {
      nickname: '$5 Creator Tip',
      interval: 'none',
      amount: 500,
      type: 'normal'
    },
    'price_1Isr2JE7ozuiLxH2Fy4cE9fu': {
      nickname: '$20 Creator Tip',
      interval: 'none',
      amount: 2000,
      type: 'normal'
    },
    'price_1Isr2bE7ozuiLxH27PvUjUZN': {
      nickname: '$100 Creator Tip',
      interval: 'none',
      amount: 10000,
      type: 'normal'
    }
  },
  staging: {
    'price_1Iks2HE7ozuiLxH2mxptRAvo': {
      nickname: '$5 Creator Tip',
      interval: 'none',
      amount: 500,
      type: 'normal'
    },
    'price_1Isr2JE7ozuiLxH2Fy4cE9fu': {
      nickname: '$20 Creator Tip',
      interval: 'none',
      amount: 2000,
      type: 'normal'
    },
    'price_1Isr2bE7ozuiLxH27PvUjUZN': {
      nickname: '$100 Creator Tip',
      interval: 'none',
      amount: 10000,
      type: 'normal'
    }
  },
  live: {
    'price_1IkutuE7ozuiLxH2wjXg3Gj6': {
      nickname: '$5 Creator Tip',
      interval: 'none',
      amount: 500,
      type: 'normal'
    },
    'price_1Isr55E7ozuiLxH2f8nluxWc': {
      nickname: '$20 Creator Tip',
      interval: 'none',
      amount: 2000,
      type: 'normal'
    },
    'price_1Isr5CE7ozuiLxH2bvvIQHcF': {
      nickname: '$100 Creator Tip',
      interval: 'none',
      amount: 10000,
      type: 'normal'
    }
  }
};

export const stripe_plans = {
    dev: {
      'plan_HCVa4ySCEdbvF1': {
        nickname: 'Business Team',
        interval: 'month',
        amount: 10000,
        type: 'team'
      },
      'plan_HCVcemcVayW02V': {
        nickname: 'Business Team',
        interval: 'year',
        amount: 96000,
        type: 'team'
      },
      'plan_HCVgvstHLfXtCq': {
        nickname: 'NPO Team',
        interval: 'month',
        amount: 7000,
        type: 'team'
      },
      'plan_HCVfkypO4Rqm33': {
        nickname: 'NPO Team',
        interval: 'year',
        amount: 60000,
        type: 'team'
      },
      'plan_HCVXMHaaTIcs4q': {
        nickname: 'Business Pro',
        interval: 'month',
        amount: 1000,
        type: 'pro',
        updates: {
          activate: {
            users: {
              account_level: 'private'
            }
          },
          deactivate: {
            users: {
              account_level: 'normal'
            }
          }
        }
      },
      'plan_HCVUxgJALYkRQT': {
        nickname: 'Business Pro',
        interval: 'year',
        amount: 9600,
        type: 'pro',
        updates: {
          activate: {
            users: {
              account_level: 'private'
            }
          },
          deactivate: {
            users: {
              account_level: 'normal'
            }
          }
        }
      },
      'plan_HCVeOGjHnBuDdH': {
        nickname: 'NPO Pro',
        interval: 'month',
        amount: 700,
        type: 'pro',
        updates: {
          activate: {
            users: {
              account_level: 'private'
            }
          },
          deactivate: {
            users: {
              account_level: 'normal'
            }
          }
        }
      },
      'plan_HCVe3mAlwpv5S1': {
        nickname: 'NPO Pro',
        interval: 'year',
        amount: 6000,
        type: 'pro',
        updates: {
          activate: {
            users: {
              account_level: 'private'
            }
          },
          deactivate: {
            users: {
              account_level: 'normal'
            }
          }
        }
      }
    },
    staging: {
      'plan_HCVa4ySCEdbvF1': {
        nickname: 'Business Team',
        interval: 'month',
        amount: 10000,
        type: 'team'
      },
      'plan_HCVcemcVayW02V': {
        nickname: 'Business Team',
        compare_plan: 'plan_HCVa4ySCEdbvF1',
        interval: 'year',
        amount: 96000,
        type: 'team'
      },
      'plan_HCVgvstHLfXtCq': {
        nickname: 'NPO Team',
        interval: 'month',
        amount: 7000,
        type: 'team'
      },
      'plan_HCVfkypO4Rqm33': {
        nickname: 'NPO Team',
        compare_plan: 'plan_HCVgvstHLfXtCq',
        interval: 'year',
        amount: 60000,
        type: 'team'
      },
      'plan_HCVXMHaaTIcs4q': {
        nickname: 'Business Pro',
        interval: 'month',
        amount: 1000,
        type: 'pro',
        updates: {
          activate: {
            users: {
              account_level: 'private'
            }
          },
          deactivate: {
            users: {
              account_level: 'normal'
            }
          }
        }
      },
      'plan_HCVUxgJALYkRQT': {
        nickname: 'Business Pro',
        compare_plan: 'plan_HCVXMHaaTIcs4q',
        interval: 'year',
        amount: 9600,
        type: 'pro',
        updates: {
          activate: {
            users: {
              account_level: 'private'
            }
          },
          deactivate: {
            users: {
              account_level: 'normal'
            }
          }
        }
      },
      'plan_HCVeOGjHnBuDdH': {
        nickname: 'NPO Pro',
        interval: 'month',
        amount: 700,
        type: 'pro',
        updates: {
          activate: {
            users: {
              account_level: 'private'
            }
          },
          deactivate: {
            users: {
              account_level: 'normal'
            }
          }
        }
      },
      'plan_HCVe3mAlwpv5S1': {
        nickname: 'NPO Pro',
        compare_plan: 'plan_HCVeOGjHnBuDdH',
        interval: 'year',
        amount: 6000,
        type: 'pro',
        updates: {
          activate: {
            users: {
              account_level: 'private'
            }
          },
          deactivate: {
            users: {
              account_level: 'normal'
            }
          }
        }
      }
    },
    live: {
      'plan_HDaAjDHNQ1GhNw': {
        nickname: 'Business Team',
        interval: 'month',
        amount: 10000,
        type: 'team'
      },
      'plan_HDaA1agPtgaRvK': {
        nickname: 'Business Team',
        compare_plan: 'plan_HDaAjDHNQ1GhNw',
        interval: 'year',
        amount: 96000,
        type: 'team'
      },
      'plan_HDa8cI5n9KWjep': {
        nickname: 'NPO Team',
        interval: 'month',
        amount: 7000,
        type: 'team'
      },
      'plan_HDa7gJ0Xioboqb': {
        nickname: 'NPO Team',
        compare_plan: 'plan_HDa8cI5n9KWjep',
        interval: 'year',
        amount: 60000,
        type: 'team'
      },
      'plan_HDaBhDZBkIx7Yo': {
        nickname: 'Business Pro',
        interval: 'month',
        amount: 1000,
        type: 'pro',
        updates: {
          activate: {
            users: {
              account_level: 'private'
            }
          },
          deactivate: {
            users: {
              account_level: 'normal'
            }
          }
        }
      },
      'plan_HDaAE5QQzGdRiD': {
        nickname: 'Business Pro',
        compare_plan: 'plan_HDaBhDZBkIx7Yo',
        interval: 'year',
        amount: 9600,
        type: 'pro',
        updates: {
          activate: {
            users: {
              account_level: 'private'
            }
          },
          deactivate: {
            users: {
              account_level: 'normal'
            }
          }
        }
      },
      'plan_HDa9370xc2kEDy': {
        nickname: 'NPO Pro',
        interval: 'month',
        amount: 700,
        type: 'pro',
        updates: {
          activate: {
            users: {
              account_level: 'private'
            }
          },
          deactivate: {
            users: {
              account_level: 'normal'
            }
          }
        }
      },
      'plan_HDa80VGsEahUYN': {
        nickname: 'NPO Pro',
        compare_plan: 'plan_HDa9370xc2kEDy',
        interval: 'year',
        amount: 6000,
        type: 'pro',
        updates: {
          activate: {
            users: {
              account_level: 'private'
            }
          },
          deactivate: {
            users: {
              account_level: 'normal'
            }
          }
        }
      }
    },
};
